import { ResourceType } from "@/enums";

interface AmiraResourcesResponse {
  branding: string;
  label: string;
  provider: string;
  resourceIcon: string;
  resourceId: string;
  resourceType: string;
  url: string;
}

const resourceTypesToIncludeFromSkillsModal = [
  ResourceType.teacherResource
]

export const filterResourceForReports = (resources: AmiraResourcesResponse[]) => {
  // return only the resources that are in the resourceTypesToIncludeFromSkillsModal array
  return resources.filter(resource => resourceTypesToIncludeFromSkillsModal.includes(resource.resourceType as ResourceType));
}